import React from "react";
import axios from "axios";
import Grid from '@mui/material/Grid';
import ActionAlert from "../Alert/ActionAlert.jsx";
import CardMarkerSmall from "./CardMarkerSmall.jsx";
import NewbornCardAccordion from "../TextComps/NewbornCardAccordion.jsx";
import TrafficlightButtonRed from "../Button/TrafficlightButtonRed.jsx";
import TrafficlightButtonGreen from "../Button/TrafficlightButtonGreen.jsx";


export default function NewbornPanelsCardTemplate(props) {

const {panel_url, panel_name, panel_subtext } = props

const url_panel = {panel_url}
const [variantInfo, setVariantInfo] = React.useState(null);
const [error, setError] = React.useState(null);

React.useEffect(() => {retrievePanel();}, []);

const retrievePanel = () => {
  axios
    .get(url_panel.panel_url)
    .then((res) => {
      setVariantInfo(res.data);

    })
    .catch(function (error) {
      if (error.response) {
        // Request made and server responded
        setError(error.response.data);
      } else if (error.request) {
        // The request was made but no response was received
        setError("The request was made but no response was received.");
      } else {
        // Something happened in setting up the request that triggered an Error
        setError("Error: " + error.message);
      }
    });
};

return(
<>

{variantInfo ? 

      <CardMarkerSmall

        headline = {panel_name} 
        subtext = {panel_subtext}
        cardlines = {<>

        {variantInfo.map((i, index) => 
              
              <NewbornCardAccordion key={index} 

                  name = {i.condition}
                  icon_1 = {i.traffic_light === 'green' ? <TrafficlightButtonGreen /> : <TrafficlightButtonRed />}

                  panel = {i.panel}
                  condition = {i.condition}
                  genes_id={"Genes analysed:  "}
                  genes = {i.genes}
          
         />  
      )}  
      </>}

    />

 : 

    <Grid mt={2} mb={2} justifyContent="center" container spacing={2}>
        <Grid item lg={12} md={12} sm={12} xs={12}>
        <ActionAlert
            severity="warning"
            message={"Currently no information available"}
        />
        </Grid>
    </Grid>

}

{error && (
          <Grid mt={2} mb={1} justifyContent="center" container spacing={1}>
            <Grid item lg={12} md={12} sm={12} xs={12}>
              <ActionAlert severity="error" message={error.message} />
            </Grid>
          </Grid>
)}

</> 
)
}

